import { render, staticRenderFns } from "./chooseShebei.vue?vue&type=template&id=275f6d6e"
import script from "./chooseShebei.vue?vue&type=script&lang=js"
export * from "./chooseShebei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports